(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateBar(cart) {
    var el = document.getElementById('CartDrawer-FreeShipping');
    if (!el || !cart) return;

    var threshold = parseInt(el.dataset.threshold, 10) || 7500;
    var total = cart.total_price || 0;
    var remaining = Math.max(threshold - total, 0);
    var progress = Math.min(Math.round((total / threshold) * 100), 100);

    el.dataset.total = total;
    var msg = el.querySelector('.cart-drawer__free-shipping-msg');
    var track = el.querySelector('.cart-drawer__free-shipping-track');
    var fill = el.querySelector('.cart-drawer__free-shipping-fill');

    if (!msg || !fill) return;

    if (total >= threshold) {
      msg.className = 'cart-drawer__free-shipping-msg cart-drawer__free-shipping-msg--success';
      msg.textContent = "You've unlocked free shipping!";
    } else {
      msg.className = 'cart-drawer__free-shipping-msg';
      msg.innerHTML = "You're <strong>" + formatMoney(remaining) + '</strong> away from free shipping';
    }

    fill.style.width = progress + '%';
    if (track) {
      track.setAttribute('aria-valuenow', progress);
    }
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(updateBar)
      .catch(function () {});
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCart);
    }
    document.addEventListener('cart:refresh', fetchCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
